<template>
  <div
    class="flex items-center overflow-hidden rounded-lg border border-gray-200 bg-white"
    :class="[widthClass, small ? 'h-8' : 'h-10']"
  >
    <button
      type="button"
      class="flex h-full items-center px-2 text-gray-600 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
      :disabled="!canGoPrev"
      :aria-label="prevLabel"
      @click="$emit('prev')"
    >
      <BaseIcon name="arrow-left-s" :class="small ? 'text-base' : 'text-lg'" />
    </button>
    <span
      class="flex-1 px-2 text-center text-sm"
      :class="labelClass"
      aria-live="polite"
    >
      {{ label }}
    </span>
    <button
      type="button"
      class="flex h-full items-center px-2 text-gray-600 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
      :disabled="!canGoNext"
      :aria-label="nextLabel"
      @click="$emit('next')"
    >
      <BaseIcon name="arrow-right-s" :class="small ? 'text-base' : 'text-lg'" />
    </button>
  </div>
</template>

<script setup>
import { BaseIcon } from "@repowerednl/ui-component-library"

defineProps({
  label: { type: String, required: true },
  canGoPrev: { type: Boolean, default: false },
  canGoNext: { type: Boolean, default: false },
  prevLabel: { type: String, required: true },
  nextLabel: { type: String, required: true },
  labelClass: { type: String, default: "min-w-36" },
  widthClass: { type: String, default: "" },
  // Matches the height of BaseButton-based toolbar controls (h-8 vs h-10) so
  // the navigator lines up with its neighbours.
  small: { type: Boolean, default: false },
})

defineEmits(["prev", "next"])
</script>
